import { createContext, useCallback, useContext, type PropsWithChildren } from 'react';

const AppReloadContext = createContext<() => void>(() => window.location.reload());

export function AppReloadProvider({ children, onReload }: PropsWithChildren<{ onReload?: () => void }>) {
  const reload = useCallback(() => {
    onReload ? onReload() : window.location.reload();
  }, [onReload]);

  return <AppReloadContext.Provider value={reload}>{children}</AppReloadContext.Provider>;
}

export function useAppReload() {
  return useContext(AppReloadContext);
}
